export default "__VITE_ASSET__BKnl9ugn__"